import PropTypes from 'prop-types';
import React, { Component, Children } from 'react';
import { TYPES, EDITOR_PANELS } from 'crazyEditor/core/constants/panelConstants';
import { connect } from 'react-redux';
import _ from 'lodash';
import { openLazyPanel } from 'crazyEditor/redux/modules/panel/panel';
import update from 'react-addons-update';

export default class MuiThemeUpdater extends Component {
  static childContextTypes = {
    muiTheme: PropTypes.object,
  };

  getChildContext = () => {
    const {muiTheme} = this.context;
    const {themeUpdate} = this.props;
    return { muiTheme: update(muiTheme, themeUpdate) };
  };

  render() {
    return Children.only(this.props.children);
  }
}

MuiThemeUpdater.contextTypes = {
  muiTheme: PropTypes.object.isRequired,
};